import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { createStructuredSelector } from 'reselect';
import Typography from '@quintoandar/cozy-core/Typography';
import Autorenew from '@quintoandar/cozy-icons/Autorenew';
import {
  uploadPhotoAction,
  addPhotosToUploadAction } from 'containers/PhotosManager/action';
import Box from '@quintoandar/cozy-core/Box';
import {
  makeSelectPhotoHasFinishedUplaod,
  makeSelectPhotosToUpload,
} from 'containers/PhotosManager/selectors';
import messages from '../messages';

export const DropUpload = ({
  houseType,
  houseId,
  galleryType,
  photosToUpload,
  uploadPhotos,
  addPhotosToUpload,
  hasFinishedPhotoUpload,
}) => {
  const onDropAccept = (acceptedFiles) => {
    addPhotosToUpload(acceptedFiles);
  };

  useEffect(() => {
    if (photosToUpload.length && hasFinishedPhotoUpload) {
      const [firstFile, ...otherFiles] = photosToUpload;

      uploadPhotos(houseType, houseId, firstFile, galleryType);
      addPhotosToUpload(otherFiles);
    }
  }, [photosToUpload, hasFinishedPhotoUpload]);

  return (
    <Dropzone onDropAccepted={onDropAccept} accept="image/jpeg" multiple>
      {({ getRootProps, getInputProps }) => (
        <Box {...getRootProps()}>
          <input {...getInputProps()} />
          <Box
            bgcolor="#FAFAFA"
            border="1px dashed #BDBDBD"
            boxsizing="border-box"
            borderRadius="8px"
            height="380px"
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            flexDirection="column"
            textAlign="center"
          >
            <svg height="98" width="103" style={{ margin: '0 auto' }}>
              <ellipse cx="51.435" cy="48.5" rx="51.435" ry="48.5" style={{ fill: '#EEEEEE' }} />
              <Autorenew x="39.435" y="36.5" height="24" width="24" style={{ margin: '0 auto', color: '#757575' }} />
            </svg>
            <Box mt={1.75}>
              <Typography>
                {galleryType === 'photosphere' ?
                  <FormattedMessage {...messages.clickToUploadLabel} /> :
                  <FormattedMessage {...messages.clickToUploadPhotoLabel} />
                }
              </Typography>
            </Box>
            <Box mt={0.625}>
              <Typography>
                <FormattedMessage {...messages.dragAndDropLabel} />
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Dropzone>
  );
};

export const mapStateToProps = createStructuredSelector({
  hasFinishedPhotoUpload: makeSelectPhotoHasFinishedUplaod(),
  photosToUpload: makeSelectPhotosToUpload(),
});

export const mapDispatchToProps = (dispatch) => ({
  uploadPhotos: (houseType, houseId, files, galleryType) =>
    dispatch(uploadPhotoAction(houseType, houseId, files, galleryType)),
  addPhotosToUpload: (files) => dispatch(addPhotosToUploadAction(files)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

DropUpload.propTypes = {
  galleryType: PropTypes.string,
  houseId: PropTypes.string,
  houseType: PropTypes.string,
  uploadPhotos: PropTypes.func.isRequired,
  addPhotosToUpload: PropTypes.func.isRequired,
  hasFinishedPhotoUpload: PropTypes.bool,
  photosToUpload: PropTypes.array,
};

export default compose(
  withConnect,
)(DropUpload);
